export const SET_AP_STATUS = 'SET_AP_STATUS';
export const SET_SWITCH_STATUS = 'SET_SWITCH_STATUS';
export const SWITCH_STATUS_CHANGE = 'SWITCH_STATUS_CHANGE';
export const SET_RADIO_STATUS = 'SET_RADIO_STATUS';
export const SET_GROUP_STATUS = 'SET_GROUP_STATUS';
export const SET_ALARM_STATUS = 'SET_ALARM_STATUS';
export const SET_CLIENT_STATUS = 'SET_CLIENT_STATUS';
export const SET_SWITCH_ALARM_STATUS = 'SET_SWITCH_ALARM_STATUS';
export const SET_SUB_SITE_STATUS = 'SET_SUB_SITE_STATUS';
export const SET_SSID_STATUS = 'SET_SSID_STATUS';
